/*
*  core configuration for farbcode projects
*
*/
import vueSelect from 'vue-select'

//import pinia and pinia persist
//import { createPinia } from 'pinia'
//import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

//setup pinia
//const pinia = createPinia()
//pinia.use(piniaPluginPersistedstate)


export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('VSelect', vueSelect)
})
